// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width {
  width: 100%;
}

:host ::ng-deep .custom-apperance .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix {
  padding: 0.5em 0 0.5em 0;
}
::ng-deep .mat-dialog-container{
  margin: 0 !important;
  padding: 0 !important ;
}`, "",{"version":3,"sources":["webpack://./src/app/views/view-builder/add-page-title/add-page-title.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":[".full-width {\r\n  width: 100%;\r\n}\r\n\r\n:host ::ng-deep .custom-apperance .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix {\r\n  padding: 0.5em 0 0.5em 0;\r\n}\r\n::ng-deep .mat-dialog-container{\r\n  margin: 0 !important;\r\n  padding: 0 !important ;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
